<div class="warp-all-group" [ngClass]="{'blue':open,'in-select':isSelect}">
    <div class="group">
        <div class="group-details">
            <div (click)="openGroup()" *ngIf="displayUsers">
                <img src="/assets/images/types/dropdown.svg" class="dropdown-img" *ngIf="this.open" />
                <img src="/assets/images/types/dropdown-close.svg" class="dropdown-img scale-img" *ngIf="!this.open" />
            </div>

            <div class="group-logo">
                <que-distribution-group-square [color]="group?.color" [name]="group?.name"
                    [size]="'35px'"></que-distribution-group-square>
            </div>
            <div class="ellipsis">
                <p class="ellipsis">{{group?.name}}</p>
            </div>
            <que-recipients-display *ngIf="displayUsers" [recipients]="group?.users"
                [isStatusReply]="false"></que-recipients-display>
        </div>

        <div class="delete pointer" (click)="delete()" *ngIf="displayUsers&&canDelete">
            <img src="/assets/images/popup-recipient/delete.svg">
        </div>
    </div>
    <div *ngIf="open" class="recipients-list">
        <div *ngFor="let recipient of group?.users">
            <que-contact-display [contact]="recipient" [isGroup]="true"></que-contact-display>
        </div>
    </div>
</div>